import { Vue, Prop } from "vue-property-decorator";
import { ShowcasePageData } from "fs-pb-vue2/data/showcasePageData";
import { ShowCaseActionType } from "fs-pb-vue2/data/enums/showCaseActionType";
import { ShowcaseFinProductData } from "fs-pb-vue2/data/showcaseFinProductData";

export class ShowCaseFinProductVueGB extends Vue {

  @Prop() pageObj!: ShowcasePageData;

  finProduct: ShowcaseFinProductData | null = null;

  currentAmount: number = 0;

  get formattedText() {
    return this.finProduct?.text ? this.finProduct.text.replace(/(\r\n|\n|\r)/g, '<br>') : '';
  }

  updateAmount(): void {
    if (this.finProduct) {
      const min = this.finProduct.sliderMin;
      const max = this.finProduct.sliderMax;

      this.currentAmount = Math.max(min, Math.min(this.currentAmount, max));
    }
  }

  callAction(finProduct: any): void {
    if (finProduct) {
      switch (finProduct.actionType) {
        case ShowCaseActionType.Close:
          console.log('Close action');
          this.$router.go(-1);
          break;
        case ShowCaseActionType.OpenLinkInApp: {
          let query = '';
          if (finProduct.sumPropertyName && finProduct.sumPropertyName.trim() !== '') {
            query = `&${finProduct.sumPropertyName}=${this.currentAmount}&сreditRequest=true`;
          }

          this.$router.push(`/${finProduct.actionLink}${query}`)
          break;
        }
        case ShowCaseActionType.OpenLinkInBrowser:
          window.open(this.$options.filters.url(finProduct.actionLink), '_blank');
          break;
        case ShowCaseActionType.DownloadFile: {
          const link = document.createElement("a");
          link.href = this.$options.filters.url(finProduct.actionLink);
          link.download = finProduct.actionLink.substring(finProduct.actionLink.lastIndexOf('/'));
          link.target = '_blank';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          break;
        }
        default:
          console.log('None action');
          break;
      }
    }
  }

  init(): void {
    if (this.pageObj && this.pageObj.Data) {
      this.finProduct = new ShowcaseFinProductData(this.pageObj.Data);
      this.currentAmount = this.finProduct.sliderDefault;
    } 
  }
}
